module.exports = __webpack_public_path__ + "static/img/ys_bg.c2177d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Virus/Adenovirus/ys_bg.png
// module id = ymKE
// module chunks = 16